<template>
  <div :class="[textEli ? 'text-eli' : '']">
    <template v-if="type === 'systemUser'">
      <el-popover
        effect="light"
        placement="top"
        trigger="click"
        @show="queryUserInfo(query.userId)"
      >
        <el-descriptions :column="1" border v-loading="userLoading">
          <el-descriptions-item label="手机号">{{ userInfo.mobile }}</el-descriptions-item>
          <el-descriptions-item label="供应商">{{ userInfo.merchantName }}</el-descriptions-item>
        </el-descriptions>
        <template slot="reference">
          <span class="link">
            {{ label }}
          </span>
        </template>
      </el-popover>
    </template>
    <template v-else>
      <el-tooltip placement="right" effect="dark" trigger="hover" :disabled="!needCopy">
        <a
          v-if="isPermi && value"
          href="#"
          @click.prevent="clickEvent"
          class="label-color"
          :class="need ? 'link' : ''"
        >
          <!-- :class="[isClick ? 'active' : '']" -->
          {{ label }}
        </a>
        <span v-else>{{ label }}</span>
        <template v-slot:content>
          <span style="cursor: pointer" @click="copyOrderNo(value)">复制</span>
        </template>
      </el-tooltip>
    </template>
  </div>
</template>

<script >
import { getUserInfo } from '@/api/common';
import { ref, computed, toRefs } from '@vue/composition-api';
import { IntercityOrderInstance } from '@/util/userOpenOrder.js';
import { copyText } from '@/util';
import { Message } from 'element-ui';
import store from '@/store';
// import router from '@/router/router'
const __sfc_main = {};
__sfc_main.props = {
  value: {
    type: String || Number,
    default: () => ''
  },
  url: {
    type: String,
    default: () => ''
  },
  query: {
    type: Object,
    default: () => {}
  },
  permi: {
    type: String,
    default: ''
  },
  type: {
    type: String,
    default: ''
  },
  need: {
    type: Boolean,
    default: false
  },
  // 文字过长省略
  textEli: {
    type: Boolean,
    default: true
  },
  needCopy: {
    type: Boolean,
    default: false
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const props = __props;
  const {
    url,
    type,
    query,
    permi
  } = toRefs(props);
  const emit = __ctx.emit;
  const label = computed(() => {
    return props.value ? props.value : '-';
  });
  const isClick = ref(false);

  // 判断是否有权限
  const isPermi = computed(() => {
    // permi 为非必传参数，默认为空，则默认有权限
    if (!permi.value) return true;
    const {
      acpermission = []
    } = store.state.user || {};
    if (!acpermission || !acpermission.length) {
      return false;
    }
    return acpermission.includes(permi.value);
  });

  // 点击事件
  const clickEvent = () => {
    emit('click');
    isClick.value = true;
    // if (url.value) {
    //   router.push({ path: url.value, query: query.value })
    //   return
    // }
    if (type.value === 'userInfo' || type.value === 'driverInfo') {
      const _url = url.value.indexOf('?') === -1 ? url.value + '?closeAllTag=true' : url.value + '&closeAllTag=true';
      window.open(_url);
      return;
    }
    const params = query.value || {};
    IntercityOrderInstance.init({
      ...params,
      type: type.value
    });
  };

  // 查用户信息
  const userLoading = ref(false);
  const userInfo = ref({});
  const queryUserInfo = async userId => {
    const {
      mobile
    } = userInfo.value || {};
    if (mobile) {
      return;
    }
    userLoading.value = true;
    const res = await getUserInfo({
      userId
    });
    userLoading.value = false;
    const {
      code,
      data
    } = res || {};
    if (code !== 0) {
      return;
    }
    userInfo.value = data || {};
  };
  const copyOrderNo = async orderNo => {
    if (!orderNo) {
      return;
    }
    await copyText(orderNo);
    Message.success('复制成功');
  };
  return {
    type,
    query,
    label,
    isPermi,
    clickEvent,
    userLoading,
    userInfo,
    queryUserInfo,
    copyOrderNo
  };
};
export default __sfc_main;
</script>

<style lang="scss" scoped>
  @import '@/styles/element-ui.scss';

  .link {
    cursor: pointer;
    color: $primary-btn-text-color;
    font-weight: 600;
    // &:hover {
    //   color: $primary-btn-text-hover-color;
    // }
  }
  .label-color:hover {
    color: $primary-btn-text-color;
  }
  // .active {
  //   color: $primary-btn-text-active-color;
  // }
</style>
